<div class="header-container">
    <app-header-top [showFlag]="showFlag" [showFirstRowHeader]="showFirstRowHeader" [showSecondRowHeader]="showSecondRowHeader" [showLogo]="showLogo" [showMyAccount]="showMyAccount" (searchBarEvent)="onSearchBarEvent($event)"> </app-header-top>
    <app-header-nav> </app-header-nav>
    <!-- <app-header-nav *ngIf="!showThirdRowHeader" [ngStyle]="{'display': !!showSearchBar ? 'none' : 'block'}"></app-header-nav> -->
</div>